import { render, staticRenderFns } from "./CustomTextarea.vue?vue&type=template&id=b65290f8&scoped=true&"
import script from "./CustomTextarea.vue?vue&type=script&lang=js&"
export * from "./CustomTextarea.vue?vue&type=script&lang=js&"
import style0 from "./CustomTextarea.vue?vue&type=style&index=0&id=b65290f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65290f8",
  null
  
)

export default component.exports